const regionLocale = (countryCode) => {
  try {
    const locale = new Intl.Locale(`und-${(countryCode || '').toUpperCase()}`).maximize();
    return locale.region ? `${locale.language}-${locale.region}` : locale.language;
  } catch {
    return 'en';
  }
};

export const formatMoney = (amount, currency, countryCode) => {
  try {
    return new Intl.NumberFormat(countryCode ? regionLocale(countryCode) : 'en', {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${currency} ${amount}`;
  }
};
